/**
 * FormData write contract for DocumentationAdd / DocumentationDetail → POST /api/measures.
 *
 * Browser FormData.append(null) becomes the literal string "null", which MySQL
 * rejects for integer FK columns (protocol_type_id / measure_complexity_id).
 * Nested relation objects from formik.setValues(measure) must never be appended.
 */

export const MEASURE_WRITE_FIELDS = Object.freeze([
  'type',
  'article_number',
  'order_number',
  'contractor_id',
  'total_amount',
  'measure_complexity_id',
  'protocol_type_id',
]);

/** Optional nullable ID / amount fields that must never serialize as "null". */
export const MEASURE_NULLABLE_WRITE_FIELDS = Object.freeze([
  'total_amount',
  'measure_complexity_id',
  'protocol_type_id',
  'contractor_id',
]);

/**
 * Normalize a scalar form value for FormData.
 * null | undefined | "null" | "undefined" → "" (accepted by MeasureController ?: null).
 * Objects/arrays are not write scalars → "".
 */
export function normalizeMeasureFormDataValue(value) {
  if (value == null) return '';
  if (value === 'null' || value === 'undefined') return '';
  if (typeof value === 'object') return '';
  return value;
}

/**
 * Append only the Measure store write fields. Skips nested API relations
 * (contractor, files, *_user, …) that appear after formik.setValues(measure).
 *
 * @param {FormData} formData
 * @param {object|null|undefined} values
 * @returns {FormData}
 */
export function appendMeasureWriteFormData(formData, values) {
  const payload = values && typeof values === 'object' ? values : {};
  MEASURE_WRITE_FIELDS.forEach((key) => {
    formData.append(key, normalizeMeasureFormDataValue(payload[key]));
  });
  return formData;
}
